



































































































































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import DetailStore from '@/store/DetailStore';

@Component({
    components: {}
})
export default class Graph2dContentApp extends Vue {
    detailData = DetailStore.state;

    isDown = false;
    slideX = '55px' as any;
    percentage = 5;
    timer = null;

    reset () {
        this.percentage = 5;
        this.slideX = '55px';
    }

    callData (num) {
        let {subjectId, entityType} = this.detailData.graphInfo;
        if (entityType === 'user') {
            DetailStore.getUserGraph({subjectId, allValue: num});
        } else if (entityType === 'poi') {
            DetailStore.getPoiGraph({subjectId, allValue: num});
        }
    }

    onSlideMousedown (e) {
        e.stopPropagation();
        this.isDown = true;
        console.log('in');
    }
    onSlideMousemove (e) {
        if (!this.isDown) {
            return void 0;
        }

        let rectObj = (this.$refs.perch as HTMLDivElement).getBoundingClientRect() as any;
        let pageX = e.clientX || e.touches[0].pageX;
        let moveX = pageX - rectObj.x - 5;
        if (moveX <= 0) {
            moveX = 0;
        }
        if (moveX > 120) {
            moveX = 120;
        }
        this.slideX = moveX + 'px';
        this.percentage = Math.max(parseInt('' + (moveX / 120 * 100 / 10)), 1);
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.callData(this.percentage);
        }, 1000);
    }
    onSlideMouseup (e) {
        e.stopPropagation();
        this.isDown = false;
        console.log('out');
    }
    mounted () {
        this.$bus.$on('slider-reset', () => {
            console.log('in slider-reset');
            this.reset();
        })
    }
    beforeDestroy () {

    }
}
